import { useQuery } from "react-query";

import { fetchDHLDownStatus } from "~/api";

import { transformDHLDownStatusResponse } from "./useDHLDownStatus.util";

export const useDHLDownStatus = () => {
  const { data } = useQuery("fetchDHLDownStatusQuery", fetchDHLDownStatus);
  return {
    isDHLDown: transformDHLDownStatusResponse(data),
  };
};
